module.exports = __webpack_public_path__ + "img/ssyx_04.81f9caea.jpg";